import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, settings } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(phone, password);
      toast.success(`Welcome back, ${user.name}!`);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:20, background:'radial-gradient(ellipse at 20% 50%, rgba(99,102,241,0.15) 0%, transparent 60%), var(--bg)' }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          {settings.logo_path
            ? <img src={settings.logo_path} alt="logo" style={{ height:60, marginBottom:12, objectFit:'contain' }} />
            : <div style={{ fontSize:48, marginBottom:8 }}>📝</div>
          }
          <h1 style={{ fontSize:32, fontWeight:800, color:'var(--primary-light)' }}>{settings.brand_name || 'Oexams'}</h1>
          <p style={{ color:'var(--text2)', marginTop:4 }}>{settings.tagline || 'Smart Exams for Smart Teachers'}</p>
        </div>
        <div className="card">
          <h2 style={{ fontSize:22, fontWeight:700, marginBottom:20, textAlign:'center' }}>Sign In</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Phone Number</label>
              <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Enter your phone number" required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <div style={{ position:'relative' }}>
                <input
                  type={showPw ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  style={{ paddingRight:44 }}
                />
                <button type="button" onClick={() => setShowPw(v => !v)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text2)', fontSize:18, lineHeight:1 }}>
                  {showPw ? '🙈' : '👁️'}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
              {loading ? '⏳ Signing in...' : '🔐 Sign In'}
            </button>
          </form>
          <p style={{ textAlign:'center', marginTop:20, color:'var(--text2)', fontSize:14 }}>
            No account? <Link to="/register" style={{ color:'var(--primary-light)', fontWeight:600 }}>Register here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
